
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppProductGroupsEdit from "@/components/product-group/ProductGroupsEdit.vue";
import { ProductGroup } from "@/models/base/product-group";
import { ProductGroupService } from "@/services/product-group-service";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { DossierConfigService } from "@/services";

export default Vue.extend({
	data(){
		return {
			topLevelFolders: [] as ProductGroup[],
			generalConf: DossierConfigService.getGeneralConfig(),
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{to: "/settings", value: this.$ct("general")},
				{to: "/settings/products", value: this.$ct("products")},
				{
					value: this.$ct("product-groups")
				}
			] as IBreadCrumb[];
		},
		canEdit():boolean {
			return ProductGroup.canEditGroups();
		}
	},
	methods: {
		async save(){
			let settings = DossierConfigService.getGeneralConfig();
			settings.UseSimpleGroups = this.generalConf.UseSimpleGroups;
			await DossierConfigService.saveGeneralConfig(settings);
			await ProductGroupService.updateGroups(this.topLevelFolders);
			this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
		},
		onInput(topLevelFolders:ProductGroup[]){
			this.topLevelFolders = topLevelFolders;
		}
	},
	components: {
		AppProductGroupsEdit,
		AppMobileFullScreenContainer,
		AppToolbar
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	},
});
